(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["autofull-product-coupon"] && !Shopify.designMode) return;
  try {
    function registerAutofullProductCoupon() {
    if (customElements.get('autofull-product-coupon')) return;

    customElements.define('autofull-product-coupon', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.af-product-coupon__button');
          if (!button) return;

          const selected = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(selected));
          button.textContent = selected ? button.dataset.selectedLabel : button.dataset.claimLabel;

          this.dispatchEvent(new CustomEvent('coupon:change', {
            bubbles: true,
            detail: {
              selected,
              code: this.dataset.couponCode,
              formId: this.dataset.productFormId,
              blockId: this.closest('[data-block-id]')?.dataset.blockId
            }
          }));
        }, { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerAutofullProductCoupon, { once: true });
  } else {
    registerAutofullProductCoupon();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-compare-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-compare-modal')) {
    class ProductCompareModal extends HTMLElement {
      #controller;
      #returnFocusElement;
      #documentOverflow = '';
      #closeTimer;

      connectedCallback() {
        this.#controller?.abort();
        this.#controller = new AbortController();

        this.dialog = this.querySelector('[data-compare-dialog]');
        this.leftSelect = this.querySelector('[data-compare-select="left"]');
        this.rightSelect = this.querySelector('[data-compare-select="right"]');
        this.differenceInput = this.querySelector('[data-compare-difference]');
        if (!this.dialog || !this.leftSelect || !this.rightSelect || !this.differenceInput) return;

        const signal = this.#controller.signal;
        const dialogId = this.dialog.id;

        for (const trigger of document.querySelectorAll(`[aria-controls="${dialogId}"]`)) {
          trigger.addEventListener('click', () => this.#open(trigger), { signal });
        }

        this.querySelector('[data-compare-close]')?.addEventListener('click', () => this.#close(), { signal });
        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.dialog) this.#close();
          },
          { signal }
        );
        this.dialog.addEventListener(
          'cancel',
          (event) => {
            event.preventDefault();
            this.#close();
          },
          { signal }
        );
        this.dialog.addEventListener('close', () => this.#afterClose(), { signal });
        this.leftSelect.addEventListener('change', () => this.#handleSelectionChange(this.leftSelect), { signal });
        this.rightSelect.addEventListener('change', () => this.#handleSelectionChange(this.rightSelect), { signal });
        this.differenceInput.addEventListener('change', () => this.#updateDifferenceRows(), { signal });
        this.addEventListener('click', (event) => this.#handleSwatchClick(event), { signal });

        this.#ensureDistinctSelections(this.leftSelect);
        this.#render();
      }

      disconnectedCallback() {
        const wasOpen = this.dialog?.open;
        if (this.#closeTimer) window.clearTimeout(this.#closeTimer);
        this.#controller?.abort();
        if (wasOpen) {
          this.dialog.close();
          document.documentElement.style.overflow = this.#documentOverflow;
        }
      }

      #open(trigger) {
        if (this.dialog.open) return;
        this.dialog.classList.remove('is-closing');
        this.#returnFocusElement = trigger;
        this.#documentOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }

      #close() {
        if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.dialog.close();
          return;
        }

        this.dialog.classList.add('is-closing');
        this.#closeTimer = window.setTimeout(() => this.dialog.close(), 200);
      }

      #afterClose() {
        if (this.#closeTimer) window.clearTimeout(this.#closeTimer);
        this.#closeTimer = null;
        this.dialog.classList.remove('is-closing');
        document.documentElement.style.overflow = this.#documentOverflow;
        this.#returnFocusElement?.focus();
        this.#returnFocusElement = null;
      }

      #handleSelectionChange(sourceSelect) {
        this.#ensureDistinctSelections(sourceSelect);
        this.#render();
      }

      #ensureDistinctSelections(sourceSelect) {
        const otherSelect = sourceSelect === this.leftSelect ? this.rightSelect : this.leftSelect;
        if (sourceSelect.value && sourceSelect.value === otherSelect.value) {
          const replacement = Array.from(otherSelect.options).find((option) => {
            return option.value !== sourceSelect.value;
          });
          otherSelect.value = replacement?.value || '';
        }

        for (const option of this.leftSelect.options) {
          option.disabled = Boolean(option.value && option.value === this.rightSelect.value);
        }
        for (const option of this.rightSelect.options) {
          option.disabled = Boolean(option.value && option.value === this.leftSelect.value);
        }
      }

      #render() {
        this.#renderProduct('left', this.leftSelect.value);
        this.#renderProduct('right', this.rightSelect.value);
        this.#renderValues();
        this.#updateDifferenceRows();
      }

      #renderProduct(side, productId) {
        const slot = this.querySelector(`[data-compare-product-slot="${side}"]`);
        if (!slot) return;
        slot.replaceChildren();
        if (!productId) return;

        const template = Array.from(this.querySelectorAll('[data-compare-product-template]')).find((item) => {
          return item.dataset.compareProductTemplate === productId;
        });
        if (template) slot.append(template.content.cloneNode(true));
      }

      #renderValues() {
        const selections = {
          left: this.leftSelect.value,
          right: this.rightSelect.value,
        };

        for (const row of this.querySelectorAll('[data-compare-row]')) {
          const index = row.dataset.compareIndex;
          for (const side of ['left', 'right']) {
            const cell = row.querySelector(`[data-compare-cell="${side}"]`);
            if (!cell) continue;
            const valuesTemplate = Array.from(this.querySelectorAll('[data-compare-values-template]')).find((item) => {
              return item.dataset.compareValuesTemplate === selections[side];
            });
            const value = valuesTemplate?.content.querySelector(`[data-compare-value="${index}"]`)?.textContent.trim();
            cell.textContent = value || '-';
          }
        }
      }

      #updateDifferenceRows() {
        let visibleRowIndex = 0;
        for (const row of this.querySelectorAll('[data-compare-row]')) {
          const leftValue = row.querySelector('[data-compare-cell="left"]')?.textContent.trim() || '';
          const rightValue = row.querySelector('[data-compare-cell="right"]')?.textContent.trim() || '';
          row.hidden = this.differenceInput.checked && leftValue === rightValue;
          row.classList.remove('is-shaded');
          if (row.hidden) continue;
          row.classList.toggle('is-shaded', visibleRowIndex % 2 === 0);
          visibleRowIndex += 1;
        }
      }

      #handleSwatchClick(event) {
        const swatch = event.target.closest('[data-compare-swatch]');
        if (!swatch || !this.contains(swatch)) return;
        const card = swatch.closest('.product-compare-modal__product-card');
        if (!card) return;

        for (const item of card.querySelectorAll('[data-compare-swatch]')) {
          const selected = item === swatch;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        }

        const image = card.querySelector('[data-compare-image]');
        if (image && swatch.dataset.variantImage) image.src = swatch.dataset.variantImage;

        const currentPrice = card.querySelector('[data-compare-current-price]');
        if (currentPrice) currentPrice.textContent = swatch.dataset.variantPrice || '';

        const comparePrice = card.querySelector('[data-compare-compare-price]');
        if (comparePrice) {
          comparePrice.textContent = swatch.dataset.variantCompare || '';
          comparePrice.hidden = !swatch.dataset.variantCompare;
        }
      }
    }

    customElements.define('product-compare-modal', ProductCompareModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-free-gift"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      if (customElements.get('product-free-gift')) return;

      customElements.define('product-free-gift', class extends HTMLElement {
        connectedCallback() {
          this.onClick = this.onClick || this.copyCode.bind(this);
          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          clearTimeout(this.resetTimer);
          this.resetLabels();
        }

        resetLabels() {
          this.querySelectorAll('[data-gift-copy]').forEach((button) => {
            button.textContent = button.dataset.label;
          });
        }

        copyWithSelection(code) {
          const activeElement = document.activeElement;
          const selection = window.getSelection();
          const ranges = selection ? Array.from({ length: selection.rangeCount }, (_, i) => selection.getRangeAt(i).cloneRange()) : [];
          const input = document.createElement('textarea');
          input.value = code;
          input.readOnly = true;
          input.tabIndex = -1;
          input.setAttribute('aria-hidden', 'true');
          input.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0';
          document.body.appendChild(input);

          try {
            input.select();
            if (!document.execCommand('copy')) throw new Error('Copy failed');
          } finally {
            input.remove();
            activeElement?.focus({ preventScroll: true });
            if (selection) {
              selection.removeAllRanges();
              ranges.forEach((range) => selection.addRange(range));
            }
          }
        }

        async copyCode(event) {
          const button = event.target.closest('[data-gift-copy]');
          if (!button || button.disabled || !this.contains(button) || this.copying) return;

          this.copying = true;
          clearTimeout(this.resetTimer);
          this.resetLabels();

          try {
            try {
              if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
              await navigator.clipboard.writeText(button.dataset.code);
            } catch {
              this.copyWithSelection(button.dataset.code);
            }
            if (!this.isConnected) return;
            button.textContent = button.dataset.success;
          } catch {
            if (!this.isConnected) return;
            button.textContent = button.dataset.error;
          } finally {
            this.copying = false;
            if (this.isConnected) this.resetTimer = setTimeout(() => this.resetLabels(), 3000);
          }
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-g7-m6"] && !Shopify.designMode) return;
  try {
    // Gallery benefit details: native dialog with keyboard Escape support and focus return.
  (function () {
    function bindGalleryBenefitDialogClose(dialog) {
      if (!dialog || dialog.dataset.g7BenefitCloseBound === 'true') return;
      dialog.dataset.g7BenefitCloseBound = 'true';
      dialog.addEventListener('close', function () {
        var trigger = dialog.__g7BenefitTrigger;
        if (trigger && document.documentElement.contains(trigger)) trigger.focus();
        dialog.__g7BenefitTrigger = null;
      });
    }

    function bindGalleryBenefitDialogs() {
      if (document.documentElement.dataset.g7GalleryBenefitDialogsBound === 'true') return;
      document.documentElement.dataset.g7GalleryBenefitDialogsBound = 'true';

      document.addEventListener('click', function (event) {
        var openButton = event.target.closest('[data-gallery-benefit-open]');
        if (openButton) {
          var dialog = document.getElementById(openButton.dataset.galleryBenefitOpen);
          if (!dialog || typeof dialog.showModal !== 'function') return;

          bindGalleryBenefitDialogClose(dialog);
          dialog.__g7BenefitTrigger = openButton;
          if (!dialog.open) dialog.showModal();

          var closeButton = dialog.querySelector('[data-gallery-benefit-close]');
          if (closeButton) closeButton.focus();
          return;
        }

        var closeButton = event.target.closest('[data-gallery-benefit-close]');
        if (closeButton) {
          var closeDialog = closeButton.closest('dialog');
          if (closeDialog) closeDialog.close();
          return;
        }

        var clickedDialog = event.target.closest('dialog.jingva-gallery-benefit-dialog');
        if (clickedDialog && event.target === clickedDialog) clickedDialog.close();
      });

      document.querySelectorAll('dialog.jingva-gallery-benefit-dialog').forEach(bindGalleryBenefitDialogClose);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindGalleryBenefitDialogs);
    } else {
      bindGalleryBenefitDialogs();
    }
  })();

  // Shared 360° preview for the desktop trigger and mobile switch.
  (function () {
    var pageScrollLock = null;

    function lockPageScroll(dialog, scrollX, scrollY) {
      if (pageScrollLock) return;
      var root = document.documentElement;
      var body = document.body;
      var scrollbarWidth = Math.max(0, window.innerWidth - root.clientWidth);

      pageScrollLock = {
        dialog: dialog,
        scrollX: scrollX,
        scrollY: scrollY,
        rootOverflow: root.style.overflow,
        rootOverscrollBehavior: root.style.overscrollBehavior,
        bodyPosition: body.style.position,
        bodyTop: body.style.top,
        bodyLeft: body.style.left,
        bodyWidth: body.style.width,
        bodyOverflow: body.style.overflow,
        bodyOverscrollBehavior: body.style.overscrollBehavior,
        bodyPaddingRight: body.style.paddingRight
      };

      if (scrollbarWidth > 0) {
        body.style.paddingRight = (parseFloat(window.getComputedStyle(body).paddingRight) + scrollbarWidth) + 'px';
      }
      root.style.overflow = 'hidden';
      root.style.overscrollBehavior = 'none';
      body.style.position = 'fixed';
      body.style.top = -scrollY + 'px';
      body.style.left = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      body.style.overscrollBehavior = 'none';
    }

    function unlockPageScroll(dialog) {
      if (!pageScrollLock || pageScrollLock.dialog !== dialog) return;
      var root = document.documentElement;
      var body = document.body;
      var saved = pageScrollLock;
      pageScrollLock = null;

      root.style.overflow = saved.rootOverflow;
      root.style.overscrollBehavior = saved.rootOverscrollBehavior;
      body.style.position = saved.bodyPosition;
      body.style.top = saved.bodyTop;
      body.style.left = saved.bodyLeft;
      body.style.width = saved.bodyWidth;
      body.style.overflow = saved.bodyOverflow;
      body.style.overscrollBehavior = saved.bodyOverscrollBehavior;
      body.style.paddingRight = saved.bodyPaddingRight;

      var scrollBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(saved.scrollX, saved.scrollY);
      root.style.scrollBehavior = scrollBehavior;
    }

    function bindModelDialog(dialog) {
      if (dialog.dataset.g7ModelBound === 'true') return;
      dialog.dataset.g7ModelBound = 'true';
      var backdropPointer = null;

      function isOutsideDialog(event) {
        var bounds = dialog.getBoundingClientRect();
        return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      }

      dialog.addEventListener('close', function () {
        backdropPointer = null;
        var mount = dialog.querySelector('[data-g7-model-mount]');
        var modelMedia = mount.querySelector('model-media');
        if (modelMedia) modelMedia.pause();
        mount.replaceChildren();
        unlockPageScroll(dialog);
        var trigger = dialog.__g7ModelTrigger;
        if (trigger && document.documentElement.contains(trigger)) trigger.focus({ preventScroll: true });
        dialog.__g7ModelTrigger = null;
      });

      dialog.addEventListener('pointerdown', function (event) {
        backdropPointer = event.target === dialog && isOutsideDialog(event)
          ? { id: event.pointerId, x: event.clientX, y: event.clientY }
          : null;
      });

      dialog.addEventListener('pointerup', function (event) {
        if (!backdropPointer || event.pointerId !== backdropPointer.id) return;
        var moved = Math.hypot(event.clientX - backdropPointer.x, event.clientY - backdropPointer.y);
        backdropPointer = null;
        if (event.target === dialog && isOutsideDialog(event) && moved < 8) dialog.close();
      });
      dialog.addEventListener('pointercancel', function () { backdropPointer = null; });
    }

    function bindModelPreview() {
      if (document.documentElement.dataset.g7ModelPreviewBound === 'true') return;
      document.documentElement.dataset.g7ModelPreviewBound = 'true';

      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-g7-model-open]');
        if (trigger) {
          var dialog = document.getElementById(trigger.dataset.g7ModelOpen);
          if (!dialog || typeof dialog.showModal !== 'function') return;
          bindModelDialog(dialog);
          dialog.__g7ModelTrigger = trigger;
          if (!dialog.open) {
            var scrollX = window.scrollX;
            var scrollY = window.scrollY;
            dialog.showModal();
            lockPageScroll(dialog, scrollX, scrollY);
          }

          var mount = dialog.querySelector('[data-g7-model-mount]');
          var template = dialog.querySelector('[data-g7-model-template]');
          // Initialize the viewer only after the open dialog has a measurable viewport.
          mount.getBoundingClientRect();
          mount.replaceChildren(template.content.cloneNode(true));
          var modelMedia = mount.querySelector('model-media');
          var modelViewer = mount.querySelector('model-viewer');
          if (modelViewer) {
            modelViewer.setAttribute('touch-action', 'none');
            modelViewer.setAttribute('auto-rotate', '');
          }
          if (modelMedia) modelMedia.play();
          var closeButton = dialog.querySelector('.jingva-gallery-model-dialog__close');
          if (closeButton) closeButton.focus();
          return;
        }

        var resetButton = event.target.closest('[data-g7-model-reset]');
        if (resetButton) {
          var resetDialog = resetButton.closest('dialog.jingva-gallery-model-dialog');
          var resetViewer = resetDialog && resetDialog.querySelector('[data-g7-model-mount] model-viewer');
          if (!resetViewer || typeof resetViewer.resetTurntableRotation !== 'function') return;

          resetViewer.removeAttribute('auto-rotate');
          resetViewer.resetTurntableRotation();
          resetViewer.cameraOrbit = resetViewer.getAttribute('camera-orbit') || '0deg 75deg 105%';
          resetViewer.cameraTarget = resetViewer.getAttribute('camera-target') || 'auto auto auto';
          resetViewer.fieldOfView = resetViewer.getAttribute('field-of-view') || 'auto';
          resetViewer.jumpCameraToGoal();
          return;
        }

        var closeButton = event.target.closest('[data-g7-model-close]');
        if (!closeButton) return;
        var closeDialog = closeButton.closest('dialog.jingva-gallery-model-dialog');
        if (!closeDialog) {
          var gallery = closeButton.closest('product-gallery');
          closeDialog = gallery && gallery.querySelector('dialog.jingva-gallery-model-dialog');
        }
        if (closeDialog && closeDialog.open) closeDialog.close();
      });

      document.querySelectorAll('dialog.jingva-gallery-model-dialog').forEach(bindModelDialog);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindModelPreview);
    } else {
      bindModelPreview();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-promo-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const defineComponents = () => {
      if (!customElements.get('product-promo-dialog')) {
        class ProductPromoDialog extends HTMLElement {
          connectedCallback() {
            this.dialog = this.querySelector('dialog');
            this.controller = new AbortController();
            const { signal } = this.controller;
            const card = this.closest('.product-promo');

            card.addEventListener('click', (event) => {
              const opener = event.target.closest('[data-product-promo-dialog-open]');
              if (!opener || this.dialog.open) return;
              opener.focus({ preventScroll: true });
              this.dialog.showModal();
              this.querySelector('.product-promo__dialog-body').scrollTop = 0;
            }, { signal });

            this.querySelector('[data-product-promo-dialog-close]').addEventListener('click', () => this.close(), { signal });
            this.dialog.addEventListener('cancel', (event) => {
              event.preventDefault();
              this.close();
            }, { signal });

            const isOutside = (event) => {
              const rect = this.dialog.getBoundingClientRect();
              return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
            };
            let backdropPressed = false;
            this.dialog.addEventListener('pointerdown', (event) => {
              backdropPressed = event.target === this.dialog && isOutside(event);
            }, { signal });
            this.dialog.addEventListener('click', (event) => {
              if (backdropPressed && event.target === this.dialog && isOutside(event)) this.close();
              backdropPressed = false;
            }, { signal });
          }

          async close() {
            if (!this.dialog.open || this.dialog.hasAttribute('data-closing')) return;
            const { signal } = this.controller;
            this.dialog.setAttribute('data-closing', '');
            await Promise.allSettled(this.dialog.getAnimations().map((animation) => animation.finished));
            if (signal.aborted) return;
            if (this.dialog.open) this.dialog.close();
            this.dialog.removeAttribute('data-closing');
          }

          disconnectedCallback() {
            this.controller.abort();
            if (this.dialog.open) this.dialog.close();
            this.dialog.removeAttribute('data-closing');
          }
        }

        customElements.define('product-promo-dialog', ProductPromoDialog);
      }

      if (customElements.get('product-promo-timer')) return;

      class ProductPromoTimer extends HTMLElement {
        connectedCallback() {
          this.card = this.closest('.product-promo');
          this.fields = ['hours', 'minutes', 'seconds'].map((unit) => this.querySelector(`[data-unit="${unit}"]`));
          this.endTimestamp = this.parseEndTime(this.dataset.endTime);
          this.onVisibilityChange = () => {
            this.stop();
            if (!document.hidden) this.start();
          };
          document.addEventListener('visibilitychange', this.onVisibilityChange);
          this.start();
        }

        parseEndTime(value) {
          const input = (value || '').trim();
          if (/^\d{10}$/.test(input)) return Number(input) * 1000;
          if (/^\d{13}$/.test(input)) return Number(input);
          // Require an explicit offset; never interpret the merchant's date in a visitor's timezone.
          if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/i.test(input)) return NaN;
          return Date.parse(input);
        }

        start() {
          if (!Number.isFinite(this.endTimestamp)) {
            this.hidden = true;
            return;
          }
          this.hidden = false;
          if (this.update() > 0 && !document.hidden) {
            this.interval = window.setInterval(() => this.update(), 1000);
          }
        }

        update() {
          // Recalculate from timestamps on every tick to recover from sleeping/background tabs.
          const remaining = Math.max(0, Math.ceil((this.endTimestamp - Date.now()) / 1000));
          // Show total hours so a promotion more than one day away stays accurate in HH:MM:SS.
          const values = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
          this.fields.forEach((field, index) => { field.textContent = String(values[index]).padStart(2, '0'); });
          this.card.hidden = remaining === 0 && this.dataset.hideOnExpiry === 'true';
          if (remaining === 0) this.stop();
          return remaining;
        }

        stop() {
          window.clearInterval(this.interval);
          this.interval = null;
        }

        disconnectedCallback() {
          this.stop();
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
        }
      }

      customElements.define('product-promo-timer', ProductPromoTimer);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', defineComponents, { once: true });
    } else {
      defineComponents();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
